/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ authorName: NonNullable<unknown> }} Marketing_Built_ByInputs */

const en_marketing_built_by = /** @type {(inputs: Marketing_Built_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Built by ${i?.authorName}`)
};

const es_marketing_built_by = /** @type {(inputs: Marketing_Built_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Creado por ${i?.authorName}`)
};

const fr_marketing_built_by = /** @type {(inputs: Marketing_Built_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conçu par ${i?.authorName}`)
};

/**
* | output |
* | --- |
* | "Built by {authorName}" |
*
* @param {Marketing_Built_ByInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_built_by = /** @type {((inputs: Marketing_Built_ByInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Built_ByInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_built_by(inputs)
	if (locale === "es") return es_marketing_built_by(inputs)
	return fr_marketing_built_by(inputs)
});